// extracted by mini-css-extract-plugin
module.exports = {"winnerContent":"_3R56GpOzA8YtzxEbdktI71","winnerImage":"_2NqD9sP4pCRKGasQXYNinF"};